 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTCOVER from '@/components/text/Cover'
 import TEXTHALFTITLE from '@/components/text/Halftitle'
 import TEXTFRONTMATTER from '@/components/text/Frontmatter'
 import LOVE_1 from '@/components/love_1'
 import TEXTTITLE from '@/components/text/Title'
 import TEXTCOPYRIGHT from '@/components/text/Copyright'
 import TEXTDEDICATION from '@/components/text/Dedication'
 import TEXTCONTENTS from '@/components/text/Contents'
 import TEXT00A_MARSH_FM_PROD1 from '@/components/text/00a_Marsh_fm_prod-1'
 import TEXTHALFTITLE1 from '@/components/text/Halftitle1'
 import TEXT00B_MARSH_INTRODUCTION_PROD from '@/components/text/00b_Marsh_introduction_prod'
 import TEXT01_MARSH_CH1_PROD from '@/components/text/01_Marsh_ch1_prod'
 import TEXT02_MARSH_CH2_PROD from '@/components/text/02_Marsh_ch2_prod'
 import TEXT03_MARSH_CH3_PROD from '@/components/text/03_Marsh_ch3_prod'
 import TEXT04_MARSH_CH4_PROD from '@/components/text/04_Marsh_ch4_prod'
 import TEXT05_MARSH_CH5_PROD from '@/components/text/05_Marsh_ch5_prod'
 import TEXT06_MARSH_CH6_PROD from '@/components/text/06_Marsh_ch6_prod'
 import TEXT07_MARSH_CH7_PROD from '@/components/text/07_Marsh_ch7_prod'
 import TEXT08_MARSH_CH8_PROD from '@/components/text/08_Marsh_ch8_prod'
 import TEXT09_MARSH_CH9_PROD from '@/components/text/09_Marsh_ch9_prod'
 import LOVE_2 from '@/components/love_2'
 import TEXT10_MARSH_AFTERWORD_PROD from '@/components/text/10_Marsh_afterword_prod'
 import TEXT11_MARSH_BIBLIOGRAPHY_PROD from '@/components/text/11_Marsh_bibliography_prod'
 import TEXT12_MARSH_INDEX from '@/components/text/12_Marsh_Index'
 import TEXT99_MARSH_BIO_PROD from '@/components/text/99_Marsh_bio_prod'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/text/Contents",
 			"name" : "text/Contents",
 			"component" : TEXTCONTENTS
 		},
 		{
 			"path" : "/text/00a_Marsh_fm_prod-1",
 			"name" : "text/00a_Marsh_fm_prod-1",
 			"component" : TEXT00A_MARSH_FM_PROD1
 		},
 		{
 			"path" : "/text/Halftitle1",
 			"name" : "text/Halftitle1",
 			"component" : TEXTHALFTITLE1
 		},
 		{
 			"path" : "/text/00b_Marsh_introduction_prod",
 			"name" : "text/00b_Marsh_introduction_prod",
 			"component" : TEXT00B_MARSH_INTRODUCTION_PROD
 		},
 		{
 			"path" : "/text/01_Marsh_ch1_prod",
 			"name" : "text/01_Marsh_ch1_prod",
 			"component" : TEXT01_MARSH_CH1_PROD
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js